export default __webpack_public_path__ + "static/media/ic_binance_logo.46794a16.svg";